/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.21",
    versionName: "0.2.0-nightly.2025.7.21",
    versionChannel: "nightly",
    buildDate: "2025-07-21T00:08:29.853Z",
    commitHash: "a176cd77dab0af96343968f6dd53f8bfca8042b9",
};
